angular
  .module('fca-used')
  .config(l10nConfiguration)
  .factory('labelsLoader', labelsLoader)
  .run(setLocaleFormats);

l10nConfiguration.$inject = ['$translateProvider', 'CONFIG'];
function l10nConfiguration($translateProvider, CONFIG) {
  $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
  $translateProvider.useLoaderCache(true);
  $translateProvider.useLoader('labelsLoader', {
    market: CONFIG.market.id,
    brand: CONFIG.brand.id,
    language: CONFIG.language.id
  });
  $translateProvider.preferredLanguage(CONFIG.language.id);
}

labelsLoader.$inject = ['$http', 'CONFIG'];
function labelsLoader($http, CONFIG) {
  return function (options) {
    var url = CONFIG.language.endpoint;
    url = url.replace(':brand', options.brand);
    url = url.replace(':market', options.market);
    url = url.replace(':language', options.key);
    return $http.get(url)
      .catch(function () {
        return $http.get('l10n/' + options.market + '-' + options.key + '.json');
      })
      .catch(function () {
        return options.key;
      })
      .then(function (translations) {
        angular.forEach(translations.data, function (value, key) {
          delete translations.data[key];
          translations.data[key.replace(options.brand + '.', '')] = value;
        });
        /* eslint-disable dot-notation */
        if (translations.data['search_flag_premium_1'] === '') {
        /* eslint-enable dot-notation */
          CONFIG.firstLabelPremium = false;
        } else {
          CONFIG.firstLabelPremium = true;
        }
        return translations.data;
      });
  };
}

setLocaleFormats.$inject = ['$locale', 'CONFIG'];
function setLocaleFormats($locale, CONFIG) {
  $locale.NUMBER_FORMATS.GROUP_SEP = CONFIG.language.numberGroupSeparator;
  $locale.NUMBER_FORMATS.DECIMAL_SEP = CONFIG.language.numberDecimalSeparator;
}
